import { render, staticRenderFns } from "./FooterSelectors.vue?vue&type=template&id=421cf49f&"
import script from "./FooterSelectors.vue?vue&type=script&lang=js&"
export * from "./FooterSelectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports